import Swiper from 'swiper';
import 'swiper/css';
import { Navigation, Pagination } from 'swiper/modules';

const MODULE = document.querySelectorAll('[data-module="depoimentos"]');

class Depoimentos {
    constructor() {
        this.components = MODULE;
        this.init();
    }

    init() {
        this.components.forEach(component => {
            const swiperComponent = component.querySelector('.swiper');
            if (swiperComponent) this.initSwiper(swiperComponent);
        });
    }

    initSwiper(swiperComponent) {
        new Swiper(swiperComponent, {
            modules: [Pagination, Navigation],
            loop: true,
            slidesPerView: 'auto',
            navigation: {
                nextEl: swiperComponent.querySelector('.swiper-button-next'),
                prevEl: swiperComponent.querySelector('.swiper-button-prev'),
            },
            pagination: {
                el: swiperComponent.querySelector('.swiper-pagination'),
                clickable: true,
                type: 'bullets',
            },
        });
    }
}

(() => {
    if (MODULE) {
        new Depoimentos();
    }
})();

export default Depoimentos;
